import FraudIndicatorsTabs from './FraudIndicatorsTabs'

export default FraudIndicatorsTabs
